import React, { useEffect, useRef, useState } from "react";
import { PRODUCT_OUTLINE } from "./ProductLists";
import {
  BaggageClaim,
  CircleMinus,
  CirclePlus,
  ShoppingCart,
  Star,
} from "lucide-react";
import { useLocation } from "react-router-dom";
import useSWR from "swr";
import Skeleton from "../../components/Skeleton";
import toast from "react-hot-toast";
import Stock from "./Stock";
import { Modal } from "flowbite-react";

const fetchProductImage = async (productId) => {
  try {
    const response = await fetch(
      `/server/dealer_backend/fetch-item-image?productId=${productId}`
    );
    const imageObjectUrl = await response.json();
    return imageObjectUrl;
  } catch (error) {
    console.error("Error fetching product image:", error);
    return null;
  }
};

// Function to fetch inventory details based on Book_Id
const fetchInventoryDetails = async (bookId) => {
  if (!bookId) return null;
  try {
    const response = await fetch(`/server/dealer_backend/inventory/${bookId}`);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    const inventoryData = await response.json();
    return inventoryData;
  } catch (error) {
    console.error("Error fetching inventory details:", error);
    return null;
  }
};

const ProductRowItem = ({
  product,
  cart,
  handleRemoveCart,
  handleAddCart,
  handleRemoveFavorite,
  sticky,
  setsticky,
  isReturn,
}) => {
  const [quantity, setQuantity] = useState(product?.Minimum_Order_level || 1);
  const [favourite, setFavourite] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const location = useLocation();

  const inPurchaseOrder = location.pathname.startsWith("/purchase-order");
  const {
    data: imageSrc,
    isLoading,
    error,
  } = useSWR(
    product?.id ? `/fetch-item-image/${product.id}` : null,
    () => fetchProductImage(product.id),
    {
      revalidateOnFocus: false, // Prevents re-fetching on tab/window focus
      dedupingInterval: 60 * 60 * 1000, // Cache the response for 1 hour
    }
  );

  const { data: inventoryDetails, isInventoryLoading } = useSWR(
    product?.Book_Id ? `/inventory/${product.Book_Id}` : null,
    () => fetchInventoryDetails(product.Book_Id)
  );

  // console.log({inventoryDetails});
  // console.log({ inventoryError });
  const imageSrcBase = imageSrc?.imageDetail?.details?.output;
  let bondendStock;
  let nonBondendStock;
  // Bondend Stock
  console.log({ inventoryDetails });
  inventoryDetails?.item?.warehouses?.map((items) => {
    if (items?.warehouse_name == "Bonded") {
      bondendStock = items?.warehouse_actual_available_for_sale_stock;
    } else if (items?.warehouse_name == "Non-Bonded") {
      nonBondendStock = items?.warehouse_actual_available_for_sale_stock;
    }
  });
  // const bondendStock =
  // inventoryDetails?.item?.warehouses[0]?.warehouse_available_for_sale_stock;
  // inventoryDetails?.item?.warehouses[1]?.warehouse_actual_available_for_sale_stock;
  // const nonBondendStock =
  //   inventoryDetails?.item?.warehouses[0]?.warehouse_actual_available_for_sale_stock;
  // inventoryDetails?.item?.warehouses[1]?.warehouse_available_for_sale_stock;
  // Non Bondend Stock

  const handleAddToCart = () => {
    const productWithQuantity = { ...product, Quantity: quantity, Remarks: "" };
    handleAddCart(productWithQuantity);
  };

  const handleIncrement = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleDecrement = () => {
    setQuantity((prev) => {
      if (prev <= 1) return prev;
      if (prev <= product?.Minimum_Order_level)
        return product?.Minimum_Order_level;
      return prev - 1;
    });
  };

  const handleFavouriteToggle = () => {
    const favItems = JSON.parse(localStorage.getItem("favorites")) || [];

    if (favourite) {
      const updatedFavItems = favItems.filter((item) => item.id !== product.id);
      localStorage.setItem("favorites", JSON.stringify(updatedFavItems));
      setFavourite(false);
      toast.success("Removed from favorites");
      handleRemoveFavorite?.(product.id);
    } else {
      favItems.push(product);
      localStorage.setItem("favorites", JSON.stringify(favItems));
      setFavourite(true);
      toast.success("Added to favorites");
    }
  };

  const isInCart = cart.some((item) => item.id === product?.id);

  useEffect(() => {
    const favItems = JSON.parse(localStorage.getItem("favorites")) || [];
    if (favItems.some((item) => item.id === product.id)) {
      setFavourite(true);
    }
  }, [product.id]);

  // Model Hide
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setOpenModal(false);
      }
    }
    if (openModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openModal]);

  return (
    <>
      <tr
        key={product?.id}
        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
      >
        {PRODUCT_OUTLINE.map(({ api_name, aligment = "start" }, index) => {
          if (api_name === "cartActions")
            return (
              <td
                key={`cart-${product.id}-${index}`}
                index={index}
                className={`px-6 py-4 text-${aligment} ${
                  index < 1
                    ? `${sticky} left-0 z-10 bg-white hover:bg-[#f9fafb]`
                    : ""
                }`}
              >
                {!inPurchaseOrder ? (
                  isInCart ? (
                    <div className="flex items-center">
                      <button
                        onClick={handleDecrement}
                        className="px-2 text-gray-500"
                      >
                        <CircleMinus />
                      </button>
                      <span className="mx-2">
                        {cart
                          .find((item) => item.id === product.id)
                          ?.Quantity?.toString()
                          .padStart(3, "0")}
                      </span>
                      <button
                        onClick={handleIncrement}
                        className="px-2 text-gray-500"
                      >
                        <CirclePlus />
                      </button>
                      <div
                        onClick={() => handleRemoveCart(product?.id)}
                        className="cursor-pointer text-red-500 ml-2"
                      >
                        <BaggageClaim />
                      </div>
                    </div>
                  ) : (
                    <div className="flex items-center">
                      <button
                        onClick={handleDecrement}
                        className="px-2 text-blue-500"
                      >
                        <CircleMinus />
                      </button>
                      <span className="mx-2">
                        {`${quantity}`.padStart(3, "0")}
                      </span>
                      <button
                        onClick={handleIncrement}
                        className="px-2 text-blue-500"
                      >
                        <CirclePlus />
                      </button>
                      <div
                        onClick={handleAddToCart}
                        className="cursor-pointer text-blue-500 hover:text-blue-700 ml-2"
                      >
                        <ShoppingCart />
                      </div>
                    </div>
                  )
                ) : isInCart ? (
                  <button
                    onClick={() => handleRemoveCart(product?.id)}
                    className="px-2 text-red-600"
                  >
                    <CircleMinus />
                  </button>
                ) : (
                  <button
                    onClick={() =>
                      handleAddCart({ ...product, Quantity: quantity })
                    }
                    className="px-2 text-green-600"
                  >
                    <CirclePlus />
                  </button>
                )}
              </td>
            );

          if (api_name === "something")
            return (
              <td
                key={`image-${product.id}-${index}`}
                className={`px-6 py-4 ${
                  index < 2 && index >= 1 && !inPurchaseOrder
                    ? `${sticky} left-[180px]  hover:bg-[#f9fafb] bg-white`
                    : `${sticky} left-[127px] hover:bg-[#f9fafb] bg-white`
                }`}
              >
                {isLoading ? (
                  <Skeleton />
                ) : error ? (
                  <p>Error loading image!</p>
                ) : (
                  <span className="inline-block mx-auto relative">
                    <span className="absolute -top-2 -right-2 h-4 w-4 text-yellow-400">
                      <button
                        onClick={handleFavouriteToggle}
                        className="transition-all duration-200 ease-in-out transform"
                      >
                        <Star
                          className={`w-full transition-transform duration-200 ease-in-out ${
                            favourite
                              ? "fill-yellow-500 scale-110"
                              : "scale-100"
                          }`}
                        />
                      </button>
                    </span>
                    <img
                      className="w-14 aspect-square rounded-full cursor-pointer object-contain"
                      src={
                        imageSrcBase
                          ? `data:image/png;base64,${imageSrcBase}`
                          : "/app/favicon.png"
                      }
                      alt="Product"
                      // onClick={handleImageClick}
                      onClick={() => setOpenModal(true)}
                    />
                  </span>
                )}
              </td>
            );

          if (api_name === "bondedStock") {
            return (
              <>
                {isInventoryLoading ? (
                  <td>"..."</td>
                ) : (
                  <Stock stock={bondendStock} />
                )}
              </>
            );
          }
          if (api_name === "nonBondedStock") {
            return (
              <>
                {isInventoryLoading ? (
                  <td>"..."</td>
                ) : (
                  <Stock stock={nonBondendStock} />
                )}
              </>
            );
          }

          return api_name === "Product_Name" ? (
            <th
              key={`name-${product.id}-${index}`}
              scope="row"
              className="px-6 py-4 max-w-32 text-center overflow-x-auto custom-scroll-bar font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {product[api_name]}
            </th>
          ) : (
            <td
              key={`data-${product.id}-${index}`}
              className={`px-6 py-4 max-w-32 overflow-x-auto custom-scroll-bar text-${aligment}`}
            >
              {product[api_name]}
            </td>
          );
        })}
      </tr>
      <Modal
        show={openModal}
        onClose={() => setOpenModal(false)}
        ref={modalRef}
        size="md"
      >
        <Modal.Body>
          <img
            className="object-contain w-[400px]"
            src={
              imageSrcBase
                ? `data:image/png;base64,${imageSrcBase}`
                : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvT1G0T-1M2KBjEGJYsYxd5qA4j9vyejFL1ArtUQVBTxPVkPzoNS4g-K0M4HiOLwlzYPs&usqp=CAU"
            }
            alt="Product"
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductRowItem;
